//import { Type } from "typescript";

import { get } from "http";

export interface createCATCursos{
    id:string;
    codigoCurso:string;
    nombre:string;
    modalidad: string;
    contacto: string;
    objetivo: string;
    iFrame: string;
    nivel: number;
    certificacion: string;
    phone: string;
}

export class createCATCursos implements createCATCursos{
    constructor(init?:createCATCursosFormValues){
        Object.assign(this,init);
    }
}

export class createCATCursosFormValues{
    id: string="";
    codigoCurso: string = "";
    nombre: string = "";
    modalidad:  string = "";
    contacto: string = "";
    objetivos: string = ""
    iFrame: string = ""
    competencias: string = ''
    perfil: string = ''
    metodologia: string = ''
    contenido: string = ''
    certificacion: string = ''
    nivel: string = ''
    phone: string = ''

    constructor(createCATCursos?:createCATCursosFormValues){
        if(createCATCursos){
            this.id=createCATCursos.id;
            this.codigoCurso=createCATCursos.codigoCurso;
            this.nombre = createCATCursos.nombre;
            this.modalidad = createCATCursos.modalidad;
            this.contacto = createCATCursos.contacto;
            this.objetivos = createCATCursos.objetivos
            this.iFrame = createCATCursos.iFrame
            this.competencias = createCATCursos.competencias
            this.perfil = createCATCursos.perfil
            this.metodologia = createCATCursos.metodologia
            this.contenido = createCATCursos.contenido
            this.nivel = createCATCursos.nivel
            this.certificacion = createCATCursos.certificacion
            this.phone = createCATCursos.phone
        }
    }
}

export interface CATCursosL{
    id:number;
    codigoCurso:number;
    nombre:string;
}

export class CATCursosL implements CATCursosL{
    constructor(init?:CATCursosLFormValues){
        Object.assign(this,init);
    }
}

export class CATCursosLFormValues{
    id:number=0;
    codigoCurso:number=0;
    nombre:string = "";

    constructor(CATCursos?:CATCursosLFormValues){
        if(CATCursos){
            this.id=CATCursos.id;
            this.codigoCurso=CATCursos.codigoCurso;
            this.nombre = CATCursos.nombre;
        }
    }
}

// Pagination Interface Model
export interface Pagination<Type> {
    totalPages: number;
    records: Type[]
}

export interface getCATCursos{
    id:string;
    codigoCurso:string;
    nombre:string;
    modalidad: string;
    contacto: string;
    objetivos: string;
    imageUrl: string;
    bannerUrl: string;
    iFrame: string;    
    nivel: string;
    estudiantes: number;
    fechaInicio: Date;
    catedratico: string;    
    certificacion: string;
    delegacion: string;
    editions: any;
    phone: string;
}

export class getCATCursos implements getCATCursos{
    constructor(init?:getCATCursosFormValues){
        Object.assign(this,init);
    }
}

export class getCATCursosFormValues{
    id: string="";
    codigoCurso: string = "";
    nombre: string = "";
    modalidad:  string = "";
    contacto: string = "";
    objetivo: string = "";
    imageUrl: string = "";
    bannerUrl: string = "";
    iFrame: string = "";
    nivel: string = "";
    fechaInicio: Date = new Date();
    editions: any = null;
    numeroEdicion: number = 0;
    cupoActual: number = 0;
    fechaDeInicioInscripcion: Date = new Date();
    catedratico: string = "";
    is_active: boolean = false;    
    certificacion: string = '1';
    phone: string = ""

    constructor(getCATCursos?:getCATCursosFormValues){
        if(getCATCursos){
            this.id=getCATCursos.id;
            this.codigoCurso=getCATCursos.codigoCurso;
            this.nombre = getCATCursos.nombre;
            this.modalidad = getCATCursos.modalidad;
            this.contacto = getCATCursos.contacto;
            this.objetivo = getCATCursos.objetivo
            this.imageUrl = getCATCursos.imageUrl
            this.bannerUrl = getCATCursos.bannerUrl
            this.iFrame = getCATCursos.iFrame
            this.fechaInicio = getCATCursos.fechaInicio
            this.nivel = getCATCursos.nivel
            
            this.numeroEdicion = getCATCursos.numeroEdicion
            this.cupoActual = getCATCursos.cupoActual
            this.fechaDeInicioInscripcion = getCATCursos.fechaDeInicioInscripcion
            this.catedratico = getCATCursos.catedratico
            this.is_active = getCATCursos.is_active
            this.certificacion = getCATCursos.certificacion
            this.editions = getCATCursos.editions
            this.phone = getCATCursos.phone
        }
    }
}

export interface editions {
    id: number;
    is_active: boolean;
    numeroEdicion: number;
    cupoActual: number;
    fechaDeInicioInscripcion: Date;
    catedratico: string;

}

export interface lstCourses {
    id: number;
    codigoCurso: string;
    nombre: string;
    modalidad: string;
    contacto: string;
    imageUrl: string;
    editions: editions[];
    delegacion: string;
}